export const ADD_PRODUCT_REQUEST = "ADD_PRODUCT_REQUEST"
export const ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS"
export const ADD_PRODUCT_FAILURE = "ADD_PRODUCT_FAILURE"

export const Get_Product_Success = "Get_Product_Success"

export const Patch_Product_Success = "Patch_Product_Success"

export const Delete_Product_Success = "Delete_Product_Success"

export const Query_Product_Success = "Query_Product_Success"

export const Post_Address_Success = "Post_Address_Success"

export const Patch_Credit_Card = "Patch_Credit_Card"

export const GET_PRODUCT_DETAILS = "GET_PRODUCT_DETAILS"

export const DELETE_PRODUCT_DETAILS_SUCCESS = "DELETE_PRODUCT_DETAILS_SUCCESS"